import axios from 'axios';
import {all, call, fork, put, takeEvery, select} from "redux-saga/effects";

import {
    REQ_DATA_MASTER_MENU,
    GET_DATA_MASTER_MENU,
    REQ_ADD_MASTER_MENU,
    GET_ADD_MASTER_MENU,
    REQ_EDIT_MASTER_MENU,
    GET_EDIT_MASTER_MENU,
    REQ_DELETE_MASTER_MENU,
    GET_DELETE_MASTER_MENU,
    REQ_SETTING_MENU,
    REQ_SETTING_MENU_,
    GET_SETTING_MENU,
    SUCCESS_MESSAGE_MENU,
    ERROR_MESSAGE_MENU,
    BASE_URL_APIv5,
    BASE_URL_API2,
} from "constants/ActionTypes";

const getLastId = async () => {
    
    return await axios.get(`${BASE_URL_API2}/oslog/api/elasticsearch/master_menu/cmd/current-id?apiKey=c4ca4238-a0b9-2382-0dcc-509a6f75849b`)
                .then(res => res)
                .catch(error => error.response)
}

const insertLastId = async (id) => {
    const obj = JSON.stringify({id: id})
    return await axios.post(`${BASE_URL_API2}/oslog/api/elasticsearch/master_menu/cmd/current-id?apiKey=c4ca4238-a0b9-2382-0dcc-509a6f75849b`, obj)
                .then(res => res)
                .catch(error => error.response)
}

const getMasterMenu = async (token) => {
    
    return await axios.get(`${BASE_URL_APIv5}/module/list`, {
                    headers: {
                        "Authorization": `Bearer ${token}`
                    }
                })
                .then((res) => res)
                .catch((error) => error.response)
}

const setAddMenu = async (data) => {

    const object = JSON.stringify(data)
    const token = localStorage.getItem('apiKey')
    // console.log(object)

    const config = {
        headers: {
            'Content-Type': 'application/json',
            "Authorization": `Bearer ${token}`
        }
    }

    const response = await axios.post(`${BASE_URL_APIv5}/module/new`, object, config)
                    .then((res) => res)
                    .catch((error) => error.response)

    return response
  
}

const setEditMenu = async (id, data) => {
    const param = JSON.stringify(data)
    const token = localStorage.getItem('apiKey')
    // console.log(param)
    // console.log(token)

    return await axios.put(`${BASE_URL_APIv5}/module/edit/${id}`, param, {
        headers: {
            'Content-Type': 'application/json',
            "Authorization": `Bearer ${token}`
        }
    })
    .then((res) => res)
    .catch((error) => error.response)
}

const setDeleteMenu = async (id) => {
    const token = localStorage.getItem('apiKey')
    // console.log(token)

    const config = {
        headers: {
            'Content-Type': 'application/json',
            "Authorization": `Bearer ${token}`
        }
    }

    return await axios.delete(`${BASE_URL_APIv5}/module/delete/${id}`, config)
    .then((res) => res)
    .catch((error) => error.response)
}

const setDragMenu = async (data) => {
    const arr = {data_modules: data}
    const param = JSON.stringify(arr)
    const token = localStorage.getItem('apiKey')
    // console.log(param)
    // console.log(token)

    return await axios.put(`${BASE_URL_APIv5}/module/edit-all`, param, {
        headers: {
            'Content-Type': 'application/json',
            "Authorization": `Bearer ${token}`
        }
    })
    .then((res) => res)
    .catch((error) => error.response)
}


export function* setDataMasterMenu(){
    try {
        const token = localStorage.getItem('apiKey');
        const result = yield call(getMasterMenu, token);

        // console.log(result)
        
        if(result.status == 200){
            const hasil = result.data.data;
            // console.log(hasil) 
            const arr = hasil.data_modules

            yield put({type: GET_DATA_MASTER_MENU, payload: arr})
        } else {
            const alert = 'Opps! looks like something wrong'
            // console.log(alert)
        }
    } catch (error) {
        // console.log(error)
    }
}

export function* setAddMasterMenu(data){

    const obj = {
        modules_name: data.action.inputMenuName,
        alias: data.action.inputMenuAlias,
        modules_option: data.action.selectedValueRadio,
        features: data.action.obj,
        modules_path: data.action.inputMenuUrl,
        modules_icon: data.action.selectedValue,
        is_active: data.action.isActive
    }
    
    try {
        const result = yield call(setAddMenu, obj)
        // console.log(result.data)
        if(result.data.status == true){
            // console.log('data successfully created')
            const success = 'Data Successfuly Created'
            // yield put({type: GET_ADD_MASTER_MENU, payload: newObj})
            yield put({type: SUCCESS_MESSAGE_MENU, payload: success})
        } else {
            yield put({type: ERROR_MESSAGE_MENU, payload: result.data.message})
        }
        
    } catch (error) {
        const error = 'Opps! looks like something wrong'
        yield put({type: ERROR_MESSAGE_MENU, payload: error})
    }
   
}

export function* setEditMasterMenu(data){

    // console.log(data.action)
    const {id, dataObj, newData} = data.action

    try {
        const result = yield call(setEditMenu, id, dataObj)
        // console.log(result)
    
        if(result.data.status == true){
            const success = 'Data Successfuly Updated'
            yield put({type: SUCCESS_MESSAGE_MENU, payload: success})
            // yield put({type: GET_EDIT_MASTER_MENU, payload: newData})
            // console.log(success)
        }
    } catch (error) {
        const error = 'Opps! looks like something wrong'
        yield put({type: ERROR_MESSAGE_MENU, payload: error})
    }  
}

export function* setDeleteMasterMenu(data){

    const {newData, id} = data.action

    try {
        const result = yield call(setDeleteMenu, id)
        // console.log(result)
       
        if(result.status == 200){
            // console.log('delete data success')
            const success = 'Data Successfuly Deleted'
            yield put({type: SUCCESS_MESSAGE_MENU, payload: success})
            // yield put({type: GET_DELETE_MASTER_MENU, payload: newData})
        }
    } catch (error) {
        const error = 'Opps! looks like something wrong'
        yield put({type: ERROR_MESSAGE_MENU, payload: error})
    }
   
}

export function* setSettingMenu(data){
    const arr = data.action
    try {
        const result = yield call(setDragMenu, arr)
        // console.log(result)
        if(result.status == 200){
            const success = 'Data Successfuly Updated'
            yield put({type: SUCCESS_MESSAGE_MENU, payload: success})
            yield put({type: GET_DATA_MASTER_MENU, payload: arr})
            // console.log('set data to reducer')
        }
    } catch (error) {
        const error = 'Opps! looks like something wrong'
        yield put({type: ERROR_MESSAGE_MENU, payload: error})
    }
}

export function* setSettingMenu_(data){
    // console.log('func setSettingMenu_')
    const arr = data.action
    try {
        const success = 'menu object change'
        yield put({type: SUCCESS_MESSAGE_MENU, payload: success})
        yield put({type: GET_DATA_MASTER_MENU, payload: arr})
        // console.log('set data to reducer setSettingMenu_')
    } catch (error) {
        const error = 'Opps! looks like something wrong'
        yield put({type: ERROR_MESSAGE_MENU, payload: error})
    }
}

export function* reqDataMasterMenu() {
    yield takeEvery(REQ_DATA_MASTER_MENU, setDataMasterMenu);
}

export function* reqAddDataMasterMenu(){
    yield takeEvery(REQ_ADD_MASTER_MENU, setAddMasterMenu)
}

export function* reqEditDataMasterMenu(){
    yield takeEvery(REQ_EDIT_MASTER_MENU, setEditMasterMenu)
}

export function* reqDeleteMasterMenu(){
    yield takeEvery(REQ_DELETE_MASTER_MENU, setDeleteMasterMenu)
}

export function* reqSettingMenu(){
    yield takeEvery(REQ_SETTING_MENU, setSettingMenu)
}

export function* reqSettingMenu_(){
    yield takeEvery(REQ_SETTING_MENU_, setSettingMenu_)
}

export default function* rootSaga() {
    yield all([
        fork(reqDataMasterMenu),
        fork(reqAddDataMasterMenu),
        fork(reqEditDataMasterMenu),
        fork(reqDeleteMasterMenu),
        fork(reqSettingMenu),
        fork(reqSettingMenu_),
    ]);
}


// WEBPACK FOOTER //
// ./sagas/Menu.js